var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"color":"primary","dark":"","flat":""}},_vm._l((_vm.menuItems),function(item,i){return _c('v-btn',{key:i,staticStyle:{"color":"white"},attrs:{"to":item.href,"text":""}},[_vm._v(" "+_vm._s(item.text)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }